import { useSuspenseQuery } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { OCCASIONS } from '@/constants/occasions'
import { createEditorialRevealAnimation } from '@/lib/gsap/editorial-reveals'
import type { OccasionId } from '@/schemas/occasion.schema'
import { productsQueryOptions } from '@/services/products/use-products'

export interface CatalogPageModelProps {
  ocasiao?: OccasionId
}

interface CatalogPill {
  id: OccasionId | undefined
  label: string
}

export function useCatalogPageModel({ ocasiao }: CatalogPageModelProps) {
  const { data: products } = useSuspenseQuery(
    productsQueryOptions.byOptionalOccasion(ocasiao),
  )

  const gridContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (products.length === 0) {
      return
    }

    const animation = createEditorialRevealAnimation(gridContainerRef.current)
    return () => animation?.revert()
  }, [products])

  const pills: CatalogPill[] = [
    { id: undefined, label: 'Todas' },
    ...OCCASIONS.map((occasion) => ({
      id: occasion.id,
      label: occasion.title,
    })),
  ]

  return {
    products,
    activeOcasiao: ocasiao,
    pills,
    gridContainerRef,
    isEmpty: products.length === 0,
  }
}
